import { render } from "./federationName.vue?vue&type=template&id=a2430d5a&scoped=true"
import script from "./federationName.vue?vue&type=script&lang=js"
export * from "./federationName.vue?vue&type=script&lang=js"

import "./federationName.vue?vue&type=style&index=0&id=a2430d5a&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2430d5a"]])

export default __exports__